import { render, staticRenderFns } from "./jiezhen_see.vue?vue&type=template&id=1251d4c3&scoped=true&"
import script from "./jiezhen_see.vue?vue&type=script&lang=js&"
export * from "./jiezhen_see.vue?vue&type=script&lang=js&"
import style0 from "./jiezhen_see.vue?vue&type=style&index=0&id=1251d4c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1251d4c3",
  null
  
)

export default component.exports